import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const StyledProsAndConsBlock = styled.div`
  margin: ${spacing.space32} 0;
`;
